<template>
  <form class="contact-form" @submit.prevent="handleSubmit">
    <Alert :error="hasError" :alert="responseMessage" v-show="showAlert" />
    <div class="form-group">
      <input
        type="text"
        id="fullname"
        v-model="formData.fullname"
        placeholder="Qui êtes-vous?"
        required
        :disabled="isSubmitting"
      />
    </div>

    <div class="form-group">
      <input
        type="email"
        id="email"
        v-model="formData.email"
        placeholder="Votre adresse mail"
        required
        :disabled="isSubmitting"
      />
    </div>

    <div class="form-group">
      <textarea
        id="message"
        v-model="formData.message"
        placeholder="Votre message"
        rows="5"
        required
        :disabled="isSubmitting"
      ></textarea>
    </div>

    <button type="submit" :disabled="isSubmitting">
      {{ isSubmitting ? 'Envoi en cours...' : 'Envoyer' }}
    </button>
  </form>
</template>

<script setup lang="ts">
import Alert from '../elements/Alert.vue';

const { 
  submitForm, 
  resetForm,
  isSubmitting, 
  responseMessage, 
  hasError 
} = useContactForm();


const showAlert = ref(false)
const formData = reactive({
  fullname: '',
  email: '',
  message: '',
});

const handleSubmit = async () => {
  resetForm();
   showAlert.value = false;
  const result = await submitForm(formData);
   showAlert.value = true;
  
  if (result.success) {
    formData.fullname = '';
    formData.email = '';
    formData.message = '';
  }

   setTimeout(() => {
      showAlert.value = false;
    }, 3000);
};
</script>

<style lang="scss">

    .contact-form{
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding-top: 100px;
        max-width: 600px;
        width: 100%;
        margin:auto;
        @media screen and (max-width:1035px) {
          padding-top: 50px;
        }
        @media screen and (max-width:600px) {
          padding: 0 15px;
        }
        &:before{
            content: '';
            width: 300px;
            height: 95px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
            background-image: url('~/assets/svgs/form-logo.svg');
            transform: translate(-120px,-50px);
            @media screen and (max-width:600px) {
              transform: translate(10px,-20px);
              width: 200px;
        }
        }
        .form-group{
          width: 100%;
        }
        input[type="text"],input[type="email"],textarea{
            padding: 10px ;
            width: 100%;
            max-width: 600px;
            margin-bottom: 20px;
            margin-inline: auto;
            font-size: 18px;
            border: 2px solid $violet_light;
            color: $violet;
       
            &::placeholder{
                color: rgba($violet,.8);
            }
        }
        textarea{
            resize: none;
            min-height: 200px;
            height: fit-content;
        }
        button[type="submit"]{
            font-size: 20px;
        font-family: 'Open Sans',sans-serif;
        padding: 10px 20px;
        color: $white;
        background-color: $violet;
        border-radius: 50px;
        border:2px solid $violet;
        cursor: pointer;
        width: fit-content;
        text-decoration: none;
        transition: all .2s;
        @media screen and (max-width:1035px) {
            font-size: 16px;
        }
        &:hover{
            background-color: #fff;
            color: #9152F7;
        }
        }
    }
</style>